import type { NPCConfig } from '@/entities';
import V2Ending from "@/config/NPCConfigs/v2/V2Ending";

const config: NPCConfig[] = [
  {
    x: 2600,
    y: 1000,
    name: '',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_stake_elsa.png',
    hideOnState : ["ELSA_NOT_ON_STAKE"],
    repeatable : true,
    scale : 1.8,
    dialogTree: {
      startDialogId: 'stake_1',
      nodes: {
        stake_1: {
          id: 'elsa_1',
          speaker: 'Yan',
          text: `Elsa... apa kah kamu tidak apa2? `,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/stake_elsa.ktx2',
          nextDialogId : "stake_2",
        },
        stake_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan! Kamu harus meyakinkan yang lain untuk membebaskan aku!`,
          backgroundImage: '/assets/backdrop/stake_elsa.ktx2',
          nextDialogId : "elsa_2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 2600,
    y: 1000,
    name: '',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_stake.png',
    hideOnState : ["ELSA_ON_STAKE"],
    repeatable : true,
    scale : 1.8,
    dialogTree: {
      startDialogId: 'stake_1',
      nodes: {
        stake_1: {
          id: 'elsa_1',
          speaker: 'Yan',
          text: `Apa ini.. besar sekali dan terbuat dari kayu.`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/stake_empty.ktx2',
          nextDialogId : "elsa_2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 1950,
    y: 1230,
    name: 'Bunga',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_bunga.png',
    repeatable : true,
    flipSprite : true,
    scale : 1,
    hideOnState : ["BUNGA_WITH_ELSA"],
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'elsa_1',
          speaker: 'Bunga',
          text: `Semoga kita bisa cepat melewati semua ini dan kembali ke kehidupan kita`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 2080,
    y: 1200,
    name: 'Nenek',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_nenek2.png',
    repeatable : true,
    flipSprite : true,
    scale : 1,//tambahin hide on state
    dialogTree: {
      startDialogId: 'nenek_1',
      nodes: {
        nenek_1: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Yang lain sudah menunggu di Danau.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "nenek_2",
        },
        nenek_2: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Pergilah Yan, dan semoga beruntung.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          isEnd : true
        },
      },
    },
  },

  {
    x: 2570,
    y: 1120,
    name: 'Romo Darius',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_darius.png',
    repeatable : true,
    scale : 1,
    dialogTree: {
      startDialogId: 'darius_1',
      nodes: {
        darius_1: {
          id: 'darius_1',
          speaker: 'Romo Darius',
          text: `Selamat pagi Yan.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "darius_2",
        },
        darius_2: {
          id: 'darius_1',
          speaker: 'Romo Darius',
          text: `Mohon maaf Yan, situasi desa tiba-tiba menjadi seperti ini.`,
          characterImage: '/assets/character/v2/darius_sy.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "darius_3",
        },
        darius_3: {
          id: 'darius_1',
          speaker: 'Romo Darius',
          text: `Saya sudah mencoba sebaik mungkin tapi seluruh warga ingin mengetahui kebenaran.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "darius_4",
        },
        darius_4: {
          id: 'darius_1',
          speaker: '',
          text: ``,
          choices: [
            {
              text: 'Romo, aku datang dengan kebenaran.',
              nextDialogId: 'ending_1',
            },
            {
              text: 'Aku akan kembali dengan kebenaran',
              isEnd :true,
            },
          ],
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_2",
        },
        ...V2Ending
      },
    },
  },

  {
    x: 2120,
    y: 1500,
    name: '',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/crowd_animated_flipped.gif',
    repeatable : true,
    // noHitbox : true,
    scale : 2.1,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: '',
          text: `Kami tidak mau hidup dalam ketakutan`,
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: '',
          text: `Kami mau kebenaran!`,
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          isEnd : true,
        }
      },
    },
  },
  {
    x: 2550,
    y: 1350,
    name: '',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/crowd_animated.gif',
    repeatable : true,
    flipSprite : true,
    scale : 2.1,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: '',
          text: `Kami tidak mau hidup dalam ketakutan`,
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: '',
          text: `Kami mau kebenaran!`,
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          isEnd : true,
        }
      },
    },
  },
  {
    x: 2400,
    y: 1430,
    name: '',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/crowd_animated.gif',
    repeatable : true,
    flipSprite : true,
    scale : 2.1,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: '',
          text: `Kami tidak mau hidup dalam ketakutan`,
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: '',
          text: `Kami mau kebenaran!`,
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          isEnd : true,
        }
      },
    },
  },

  {
    x: 2250,
    y: 1150,
    flipSprite : true,
    name: 'Ato',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_ato.png',
    repeatable : true,
    hideOnState : ["ATO_FRIENDLY"],
    scale : 1,
    dialogTree: {
      startDialogId: 'ato_1',
      nodes: {
        ato_1: {
          id: 'ato_1',
          speaker: '',
          text: `Kita akan membalaskan dendam seluruh desa.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: '',
          text: `Temanmu akan menderita!`,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          isEnd : true,
        }
      },
    },
  },
  {
    x: 2250,
    y: 1150,
    flipSprite : true,
    name: 'Ato',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_ato.png',
    repeatable : true,
    hideOnState : ["ATO_UNFRIENDLY"],
    scale : 1,
    dialogTree: {
      startDialogId: 'ato_1',
      nodes: {
        ato_1: {
          id: 'ato_1',
          speaker: '',
          text: `Orang-orang desa tidak bisa hidup dalam ketakutan`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: '',
          text: `Kamu harus menemukan siapa Songko sebenarnay dan menghukumnya`,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          isEnd : true,
        }
      },
    },
  },

  {
    x: 2250,
    y: 1400,
    name: 'Holga',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/holga_up.png',
    repeatable : true,
    flipSprite : true,
    scale : 1,
    dialogTree: {
      startDialogId: 'holga_1',
      nodes: {
        holga_1: {
          id: 'sondakh_1',
          speaker: 'Holga',
          text: `Kamu telah terbutakan oleh Elsa`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "holga_2",
        },
        holga_2: {
          id: 'sondakh_1',
          speaker: 'Holga',
          text: `Temanmu ini jelas-jelas yang bertanggung jawab. Dan dia akan membayar.`,
          characterImage: '/assets/character/v2/holga_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_2",
          isEnd : true
        },
      },
    },
  },

  {
    x: 2480,
    y: 1080,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png',
    repeatable : true,
    hideOnState : ["ELSA_ON_STAKE"],
    scale : 1,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan, aku percaya kamu bisa memecahkan misteri ini`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          isEnd : true,
        },
      },
    },
  },


  {
    x: 2420,
    y: 1050,
    name: 'Bunga',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_bunga.png',
    hideOnState : ["BUNGA_NOT_WITH_ELSA"],
    repeatable : true,
    scale : 1,
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'darius_1',
          speaker: 'Bunga',
          text: `Ini adalah mimpi buruk bagi kita semua`,
          characterImage: '/assets/character/v2/bunga_sy.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "bunga_2",
        },
        bunga_2: {
          id: 'darius_1',
          speaker: 'Bunga',
          text: `Semoga kita bisa memecahkan misteri ini agar desa kembali hidup damai`,
          characterImage: '/assets/character/v2/bunga_sy.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "darius_3",
          isEnd : true
        },
      },
    },
  },

  // {
  //   x: 2800,
  //   y: 1050,
  //   name: 'Secret',
  //   color: 0x9932cc,
  //   spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
  //   repeatable : true,
  //   scale : 1,
  //   dialogTree: {
  //     startDialogId: 'ending_1',
  //     nodes: {
  //       ending_1: {
  //         id: 'day1_opening',
  //         speaker: 'Diana',
  //         text: `Selamat datang, terima kasih telah menjadi bagian dari tester game ini!`,
  //         characterImage: '/assets/character/v2/diana_h.png',
  //         nextDialogId: 'ending_2',
  //       },
  //       ending_2: {
  //         id: 'day1_opening',
  //         speaker: 'Diana',
  //         text: `Bagian akhir dari game ini sedang kami siapkan. `,
  //         characterImage: '/assets/character/v2/diana_h.png',
  //         nextDialogId: 'ending_3',
  //       },
  //       ending_3: {
  //         id: 'day1_opening',
  //         speaker: 'Diana',
  //         text: `Jangan lupa untuk mengisi form penilaian yang sudah kami siapkan!`,
  //         characterImage: '/assets/character/v2/diana_h.png',
  //         nextDialogId: 'ending_4',
  //       },
  //       ending_4: {
  //         id: 'day1_opening',
  //         speaker: 'Diana',
  //         text: `Selanjutnya adalah spoiler-spoiler dari semua ending yang ada.`,
  //         characterImage: '/assets/character/v2/diana_h.png',
  //         nextDialogId: 'ending_5',
  //       },
  //       ending_5: {
  //         id: 'day1_opening',
  //         speaker: 'Diana',
  //         text: `Jangan ditonton jika tidak mau mendapat spoiler ya!`,
  //         characterImage: '/assets/character/v2/diana_h.png',
  //         nextDialogId: 'day1_opening2',
  //         storyAction: { type: 'nextDay', value: 1 },
  //         isEnd : true
  //       },
  //     },
  //   },
  // },

];

export default config;
